/* Free pattern popup — behaviour for sections/freebie-popup.liquid.
   Loaded with `defer`. Vanilla JS, no requests, no dependencies. */
(function () {
  var KEY = 'sl-freebie'; // localStorage: { snoozedAt, subscribed, pending }
  var PAID_KEY = 'sl-paid-visit'; // sessionStorage: '1' when this session came from an ad
  var PAID_SOURCES = ['facebook', 'instagram', 'fb', 'ig'];
  var PAID_MEDIUMS = ['paid', 'cpc'];

  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  };

  function markPaidVisit() {
    try {
      var p = new URLSearchParams(location.search);
      var source = (p.get('utm_source') || '').toLowerCase();
      var medium = (p.get('utm_medium') || '').toLowerCase();
      if (p.has('fbclid') || PAID_SOURCES.indexOf(source) > -1 || PAID_MEDIUMS.indexOf(medium) > -1) {
        sessionStorage.setItem(PAID_KEY, '1');
      }
    } catch (e) {}
  }
  function isPaidVisit() {
    try { return sessionStorage.getItem(PAID_KEY) === '1'; } catch (e) { return false; }
  }
  function num(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  // Desktop: cursor leaves through the top of the viewport, once `minSeconds` have passed.
  function armExitIntent(open, minSeconds) {
    var start = Date.now();
    function onOut(e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (Date.now() - start < minSeconds * 1000) return;
      document.removeEventListener('mouseout', onOut);
      open();
    }
    document.addEventListener('mouseout', onOut);
  }

  // Touch: `seconds` on the page AND the visitor has scrolled at least `percent` of it.
  function armTimeAndScroll(open, seconds, percent) {
    var timeUp = false;
    var deepest = 0;
    var done = false;
    function depth() {
      var h = document.documentElement.scrollHeight;
      if (h <= window.innerHeight) return 1;
      return (window.scrollY + window.innerHeight) / h;
    }
    function check() {
      deepest = Math.max(deepest, depth());
      if (done || !timeUp || deepest * 100 < percent) return;
      done = true;
      window.removeEventListener('scroll', check);
      open();
    }
    window.addEventListener('scroll', check, { passive: true });
    setTimeout(function () { timeUp = true; check(); }, seconds * 1000);
  }

  function init(root) {
    if (!root || root.dataset.freebieReady) return;
    root.dataset.freebieReady = 'true';

    var d = root.dataset;
    var dialog = root.querySelector('.freebie__dialog');
    var lastFocus = null;
    var isOpen = false;

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('freebie-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      var first = root.querySelector('.freebie__input, .freebie__button');
      (first || dialog).focus();
    }
    function close(remember) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('freebie-open');
      setTimeout(function () { root.hidden = true; }, 250);
      if (remember !== false) {
        var s = store.get();
        s.snoozedAt = Date.now();
        store.set(s);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-freebie-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key !== 'Tab') return;
      var f = dialog.querySelectorAll('a[href], button, input:not([type="hidden"])');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });

    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      var s = store.get(); s.subscribed = true; s.pending = Date.now(); store.set(s);
    });

    // Theme editor: open when the section is selected.
    if (d.designMode === 'true') {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail.sectionId === d.sectionId) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail.sectionId === d.sectionId) close(false); });
      return;
    }

    // Returning from THIS popup's signup (the page reloads after posting): show the download link,
    // or reopen with the error so the visitor can fix their email.
    var s = store.get();
    var justPosted = location.hash === '#FreebieForm' || (s.pending && Date.now() - s.pending < 600000);
    if (justPosted) {
      delete s.pending;
      if (root.querySelector('.freebie__error')) s.subscribed = false;
      store.set(s);
      if (root.querySelector('[data-freebie-success]') || root.querySelector('.freebie__error')) { open(); return; }
    }

    if (s.subscribed) return;
    if (d.hidePaid === 'true' && isPaidVisit()) return;
    var snoozeMs = num(d.snooze, 7) * 86400000;
    if (s.snoozedAt && Date.now() - s.snoozedAt < snoozeMs) return;

    var hasMouse = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hasMouse) armExitIntent(open, num(d.desktopDelay, 10));
    else armTimeAndScroll(open, num(d.mobileDelay, 40), num(d.mobileScroll, 50));
  }

  markPaidVisit();
  document.querySelectorAll('[data-freebie-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-freebie-root]'));
  });
})();
